import ModalDefault from './Modal';

export default ModalDefault;



// WEBPACK FOOTER //
// ./src/client/Components/Modal/index.js